import { showLogs } from '@/config';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function logger(message: unknown, ...args: unknown[]) {
  if (showLogs) {
    console.log(message, ...args);
  }
}

export function openLinkInNewTab(url: string, name = '_blank') {
  const newWindow = window.open(url, name);
  return newWindow;
}
